import { RolesWithPermissions } from '../';

export const SETTINGS_ROLES: RolesWithPermissions = {
  admin: {
    settings: {
      view: true,
      updateHolidays: false,
    },
  },
  general: {
    settings: {
      view: true,
      updateHolidays: false,
    },
  },
  supervisor: {
    settings: {
      view: true,
      updateHolidays: true,
    },
  },
  backoffice: {
    settings: {
      view: true,
      updateHolidays: true,
    },
  },
  client: {
    settings: {
      view: false,
      updateHolidays: false,
    },
  },
  agency: {
    settings: {
      view: false,
      updateHolidays: false,
    },
  },
  '3rd_inspector': {
    settings: {
      view: false,
      updateHolidays: false,
    },
  },
  inspector: {
    settings: {
      view: false,
      updateHolidays: false,
    },
  },
};
